import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const UserManageNav = () => {
	const history = useHistory();
	const user = useSelector((state) => state.auth.user);

	const pathname = history.location.pathname;

	return (
		<div className={`main-nav`}>
			{user?.id === 1 && (
				<button
					className={pathname.includes("/group_buying") ? "clicked" : ""}
					onClick={() => history.push(`/group_buying`)}
				>
					공동구매
				</button>
			)}
			<button
				className={pathname.includes("/user_comment_manage") ? "clicked" : ""}
				onClick={() => history.push(`/user_comment_manage`)}
			>
				댓글 관리
			</button>
			<button
				className={
					pathname.includes("/user_mission_comment_manage") ? "clicked" : ""
				}
				onClick={() => history.push(`/user_mission_comment_manage`)}
			>
				미션 댓글 관리
			</button>
			{/*{user?.id !== 7 && (*/}
			{/*	<button*/}
			{/*		className={pathname.includes("/inquiry_manage") ? "clicked" : ""}*/}
			{/*		onClick={() => history.push(`/inquiry_manage`)}*/}
			{/*	>*/}
			{/*		상담 답변*/}
			{/*	</button>*/}
			{/*)}*/}
			{(user?.role === "level_1" || user?.role === "super_admin") && (
				<button
					className={pathname.includes("/user_message") ? "clicked" : ""}
					onClick={() => history.push(`/user_message`)}
				>
					메세지 발송
				</button>
			)}
			{(user?.role === "level_1" || user?.role === "super_admin") && (
				<button
					className={pathname.includes("/user_app_push") ? "clicked" : ""}
					onClick={() => history.push(`/user_app_push`)}
				>
					앱 푸시 발송
				</button>
			)}
			<button
				className={pathname.includes("/user_manage") ? "clicked" : ""}
				onClick={() => history.push(`/user_manage`)}
			>
				회원 관리
			</button>
		</div>
	);
};
export default UserManageNav;
